import { useAppSelector } from "../../shared/store/hooks";

/** Rôles limités à leur propre dépôt. */
const RESTRICTED_ROLES = ["responsable_boutique", "responsable", "vendeur"];

export interface UserScope {
  /** Rôle en minuscules ("" si inconnu). */
  userRole: string;
  userDepot: string;
  /** La vérification de session est terminée. */
  authChecked: boolean;
  /** Le backend a confirmé la session. */
  verified: boolean;
  /** L'utilisateur ne peut voir que son dépôt. */
  isRestricted: boolean;
}

/**
 * Rôle et dépôt de l'utilisateur connecté, tels que vérifiés par le backend.
 * Lit la session centralisée (authSlice) : aucun appel réseau ici, la
 * vérification est faite une seule fois par l'App (démarrage / login).
 */
export function useUserScope(): UserScope {
  const { status, role, depot } = useAppSelector((s) => s.auth);
  const userRole = role.toLowerCase();
  return {
    userRole,
    userDepot: depot,
    authChecked: status !== "checking",
    verified: status === "authenticated",
    isRestricted: RESTRICTED_ROLES.includes(userRole),
  };
}
